import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import validator from '../../../utils/validator';
const { isEmpty } = validator;


function StandardSystemPopup(props) {
  const { className, open, title, message, actions, onClose } = props;

  return (
    <Dialog
      className={`StandardSystemPopup ${className} ${title? 'with-title' : 'no-title'}`}
      open={open}
      onClose={() => {}}
    >
      <DialogTitle className="title">
        <span>{title}</span>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        { !isEmpty(message) &&
        <div className="content-main">
          <div dangerouslySetInnerHTML={{__html: message}} />
        </div>
        }
        { isEmpty(message) &&
          <Fragment>{props.children}</Fragment>
        }
      </DialogContent>
      { actions &&
        <DialogActions>
          <div className="content-actions">
            {actions}
          </div>
        </DialogActions>
      }
    </Dialog>
  );
}

StandardSystemPopup.defaultProps = {
  className: 'standard'
}

StandardSystemPopup.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  actions: PropTypes.object,
  onClose: PropTypes.func
};

export default StandardSystemPopup;
